import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CONFIG_URLS_API } from 'src/environments/config-envs';
import { environment } from 'src/environments/environment';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from '../services/localstorage.service';
import {
  AcordoPostoResponse,
  AcordoRedeEspecialBase,
  AcordoRedeEspecialBaseList,
  AcordoStatusResponse,
  CombustivelContrato,
  GetAcordosPendentesFilterModel,
  PayloadBuscarPrecosMacroPostos,
  PayloadCancelarAcordo,
  PayloadCriarAcordo,
  PostoResponse,
  ResponseBuscarPrecosMacroPostos,
  VerificarPrecoDeaatualizadoAsyncResponse as VerificarPrecoDesatualizadoAsyncResponse,
} from './rede-especial.interface';

@Injectable({
  providedIn: 'root',
})
export class RedeEspecialService {
  private readonly http = inject(HttpClient);
  private localStorageService = inject(LocalStorageService);
  public usuario!: LoginModel;

  constructor() {
    var userData = this.localStorageService.getItem('userData');
    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }
  private getHeaders(): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userGuid: this.usuario?.retorno?.guid,
      }),
    };
  }

  getPrecosPostosMacroPostos(
    payload: PayloadBuscarPrecosMacroPostos,
  ): Observable<ResponseBuscarPrecosMacroPostos> {
    return this.http.post<ResponseBuscarPrecosMacroPostos>(
      `${
        environment.host_ctf_service +
        CONFIG_URLS_API.API_BuscarPrecosMacroPostosAsync
      }`,
      payload,
      this.getHeaders(),
    );
  }

  getListaCombustiveis(guid: string) {
    return this.http
      .get<
        CombustivelContrato[]
      >(`${environment.host_ctf_service + CONFIG_URLS_API.API_ConsultaListaCombustiveis}${guid}`)
      .pipe(
        catchError((error) => {
          console.error('Erro ao buscar combustíveis:', error);
          return of([]);
        }),

        map((res: any) => {
          return res.retorno
            .filter(
              (combustivel: any) => combustivel.descricaoCombustivel !== '',
            )
            .sort((a: any, b: any) => {
              return a.ordem < b.ordem;
            });
        }),
      );
  }

  buscarMultiplosPosto(codigosPostos: number[]): Observable<PostoResponse> {
    const body = { CodigosPostos: codigosPostos, NomesPostos: [] };

    return this.http.post<PostoResponse>(
      `${
        environment.host_ctf_service +
        CONFIG_URLS_API.API_PegarPostosListaAcordo
      }`,
      body,
      this.getHeaders(),
    );
  }

  buscaPostoParametro(parameter: String, value: String): Observable<any> {
    let body = null;
    if (parameter === 'codPosto') {
      body = { CodigosPostos: [value], NomesPostos: [] };
    } else if (parameter === 'nomePosto') {
      body = { CodigosPostos: [], NomesPostos: [value] };
    }

    return this.http.post<PostoResponse>(
      `${
        environment.host_ctf_service +
        CONFIG_URLS_API.API_PegarPostosListaAcordo
      }`,
      body,
      this.getHeaders(),
    );
  }

  criarNovoAcordo(
    payload: PayloadCriarAcordo,
  ): Observable<AcordoRedeEspecialBase> {
    console.log('Payload Criar Acordo:', JSON.stringify(payload));

    return this.http.post<AcordoRedeEspecialBase>(
      `${environment.host_ctf_service + CONFIG_URLS_API.API_CriarNovoAcordo}`,
      payload,
      this.getHeaders(),
    );
  }

  getAcordoStatus(): Observable<AcordoStatusResponse> {
    return this.http.get<AcordoStatusResponse>(
      `${environment.host_ctf_service + CONFIG_URLS_API.API_GetAcordoStatus}`,
      this.getHeaders(),
    );
  }

  getAcordosPendentes(
    filter: GetAcordosPendentesFilterModel,
  ): Observable<AcordoPostoResponse> {
    return this.http.post<AcordoPostoResponse>(
      `${
        environment.host_ctf_service +
        CONFIG_URLS_API.API_GetAcordosPendentesAsync
      }`,
      filter,
      this.getHeaders(),
    );
  }

  aprovarOuRejeitarAcordos(
    acordos: AcordoRedeEspecialBaseList,
  ): Observable<AcordoRedeEspecialBase> {
    return this.http.post<AcordoRedeEspecialBase>(
      `${
        environment.host_ctf_service +
        CONFIG_URLS_API.API_AprovarOuRejeitarAcordosAsync
      }`,
      acordos,
      this.getHeaders(),
    );
  }

  verificarPrecoDesatualizadoAsync(): Observable<VerificarPrecoDesatualizadoAsyncResponse> {
    // return of({
    //   retorno: true,
    //   sucesso: true,
    //   mensagens: ['Preços estão atualizados'],
    // });
      return this.http.get<VerificarPrecoDesatualizadoAsyncResponse>(
        `${environment.host_ctf_service + CONFIG_URLS_API.API_VerificarPrecoDesatualizadoAsync
    }`,
        this.getHeaders(),
      );
  }

  cancelarAcordo(
    payloadAprovar: PayloadCancelarAcordo[],
  ): Observable<AcordoRedeEspecialBase> {
    return this.http.post<AcordoRedeEspecialBase>(
      `${
        environment.host_ctf_service + CONFIG_URLS_API.API_CancelarAcordosAsync
      }`,
      payloadAprovar,
      this.getHeaders(),
    );
  }
}
